import axios from './httpConfig.js'
//******************出入库管理 -- 库存 ******************/
// 实时库存SN查询
export function GetStockSNList(param) {
	return axios.post('/admin/stock/sn/list', param)
}
// 实时库存货品SN查询
export function GetStockGoodsList(param) {
	return axios.post('/admin/stock/goods/list', param)
}
// 导出 库存SN查询
export function ExportStockSNList(param) {
	return axios.postBlob('/admin/stock/sn/export', param)
}
// 导出 库存货品SN查询
export function ExportStockGoodsList(param) {
	return axios.postBlob('/admin/stock/goods/export', param)
}
//  获取SN记录的前世今生接口
export function GetSnLifeCycle(param) {
	return axios.post('/admin/stock/find/sn/history', param)
}
// 库存时间分布_接口
export function GetStockTimeDistribution(param) {
	return axios.post('/admin/stock/time_distribution', param)
}
// 库存货品分类_时间分布
export function GetStockGoodsTypeTimeDistribution(param) {
	return axios.post('/admin/stock/goodstype/time_distribution', param)
}